import { render, staticRenderFns } from "./about-page.vue?vue&type=template&id=77b8b31f&scoped=true&"
import script from "./about-page.vue?vue&type=script&lang=js&"
export * from "./about-page.vue?vue&type=script&lang=js&"
import style0 from "./about-page.vue?vue&type=style&index=0&id=77b8b31f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b8b31f",
  null
  
)

export default component.exports